export default __webpack_public_path__ + "static/media/single-project-page-04-img19.66c8b588.jpg";